import axiosInstance from "api/axios";
import { Category } from "types/category.type";

export const categoryService = {
  getAll: async (): Promise<Category[]> => {
    const { data } = await axiosInstance.get("/categories");
    return data;
  },
  create: async (form: Partial<Category>) => {
    return axiosInstance.post("/categories", form);
  },
  update: async (id: number, form: Partial<Category>) => {
    return axiosInstance.put(`/categories/${id}`, form);
  },
  delete: async (id: number) => {
    return axiosInstance.delete(`/categories/${id}`);
  },
};
